// client/click-handler.ts
import { A } from "@adornis/base/env-info.js";
import { goTo } from "./open-href.js";
window.addEventListener("click", (e) => {
  const composedPath = e.composedPath();
  const linkIndex = composedPath.findIndex((pathEl) => pathEl.nodeName === "A");
  if (linkIndex !== -1) {
    const linkElement = composedPath[linkIndex];
    const href = linkElement.getAttribute("href");
    if (href) {
      const useNativeFunctionality = hasSpecialPrefix(href) || shouldBeOpenedExternally(linkElement) || linkElement.getAttribute("target") === "_self" && href.startsWith("http");
      if (useNativeFunctionality) {
        if (A.isNative && href && !hasSpecialPrefix(href)) {
          e.preventDefault();
          goTo(href, { target: "_blank" });
        }
        return;
      }
      e.preventDefault();
      if (!href)
        return;
      if (!href.startsWith("http")) {
        goTo(href);
        document.documentElement.scrollTop = 0;
      } else {
        goTo(href, { target: "_blank" });
      }
    }
  }
});
function hasSpecialPrefix(href) {
  return !!href && (href.startsWith("mailto") || href.startsWith("tel"));
}
function shouldBeOpenedExternally(linkElement) {
  const target = linkElement.getAttribute("target");
  return target === "_blank" || target === "_system";
}
